import React, {useState} from 'react'

function Calendar(props) {
  const {type} = props
  const month = ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월']
  const [tabIdx, setTabIdx] = useState(0)
  return (
    <div className="com_calendar_wrap">
      <div className="year">
        <button className="btn btn_first"></button>
        <button className="btn btn_prev"></button>
        <button className="btn_txt">2023</button>
        <button className="btn btn_next"></button>
        <button className="btn btn_last"></button>
      </div>
      <div className="month">
        <section className="com_tab">
          {month.map((item, idx) => {
            return (
              <button key={idx} className={`tab ${tabIdx === idx ? 'active' : ''}`} onClick={() => setTabIdx(idx)}>
                {type === 'salary' ? idx < 2 ? <span className="icon">지급완료</span> : idx === 2 ? <span className="icon">지급예정</span> : <></> : <></>}
                {item}
              </button>
            )
          })}
        </section>
      </div>
    </div>
  )
}

export default Calendar
